export enum VehicleState {
    NEW_CAR = 'new-car',
    USED_CAR = 'used-car',
    JUNGWAGEN = 'jungwagen',
}
